export default __webpack_public_path__ + "static/media/gnd_kr_jing_b3.d5e553e0.mp3";